import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=7924ecf4&scoped=true&"
import script from "./formItem.vue?vue&type=script&lang=js&"
export * from "./formItem.vue?vue&type=script&lang=js&"
import style0 from "./formItem.vue?vue&type=style&index=0&id=7924ecf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924ecf4",
  null
  
)

export default component.exports